import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { motion } from 'framer-motion';
import { useAuth } from '../../context/AuthContext';
import './Navbar.css';

const Navbar: React.FC = () => {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const { user, isAdmin, logout } = useAuth();
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 50);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMenuOpen(false);
  }, [location]);

  return (
    <motion.nav
      className={`navbar ${scrolled ? 'scrolled' : ''}`}
      initial={{ y: -100 }}
      animate={{ y: 0 }}
      transition={{ duration: 0.6, ease: 'easeOut' }}
    >
      <div className="navbar-inner">
        <Link to="/" className="navbar-brand">
          <span className="brand-infinity">&#8734;</span>
          <div className="brand-text">
            <span className="brand-name">Kutloano Mkhulisi</span>
            <span className="brand-tagline">Writer</span>
          </div>
        </Link>

        <div className={`navbar-links ${menuOpen ? 'open' : ''}`}>
          <NavLink to="/" label="Home" current={location.pathname} />
          <NavLink to="/about" label="About" current={location.pathname} />
          <NavLink to="/books" label="Books" current={location.pathname} />
          <NavLink to="/poems" label="Poems" current={location.pathname} />
          <NavLink to="/stories" label="Stories" current={location.pathname} />
          <NavLink to="/forum" label="Forum" current={location.pathname} />
          {user ? (
            <>
              {isAdmin && <NavLink to="/dashboard" label="Dashboard" current={location.pathname} />}
              <button className="nav-btn logout-btn" onClick={logout}>
                Logout
              </button>
            </>
          ) : (
            <Link to="/login" className="nav-btn login-btn">
              Sign In
            </Link>
          )}
        </div>

        <button
          className={`hamburger ${menuOpen ? 'active' : ''}`}
          onClick={() => setMenuOpen(!menuOpen)}
          aria-label="Toggle menu"
        >
          <span></span>
          <span></span>
          <span></span>
        </button>
      </div>
    </motion.nav>
  );
};

const NavLink: React.FC<{ to: string; label: string; current: string }> = ({
  to,
  label,
  current,
}) => (
  <Link to={to} className={`nav-link ${current === to ? 'active' : ''}`}>
    {label}
    {current === to && (
      <motion.div className="nav-indicator" layoutId="nav-indicator" />
    )}
  </Link>
);

export default Navbar;
